async function getCartData(){
    try {
        const response = await fetch(`${ROUTES.cart_url_js}`);
        if (!response.ok) {
            throw new Error('Failed to fetch cart data');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error getting cart data:', error);
        console.log(error);
    }
}

function handleCartLoadingWrapper(is_active){
    const loadingWrapper = document.querySelector('.loading-wrapper.cart');
    if(is_active){
        loadingWrapper.classList.add('active');
    }else{
        loadingWrapper.classList.remove('active');   
    }
}

async function addToCart(e){
    e.preventDefault();
    const form = document.querySelector('.shopify-product-form');
    const quantity_input = document.getElementById('quantity');
    const max = parseInt(quantity_input.max);
    const min = parseInt(quantity_input.min);
    const formData = new FormData(form);
    if (!form) {
        console.error('Product form not found');
        return;
    }

    const variantId =parseInt(formData.get('id'));
    if (!variantId) {
        console.error('Variant ID is missing');
        return;
    }
    
    const quantity = parseInt(formData.get('quantity'));
    const cartData = await getCartData();
    const cartItem = cartData.items.find(item => item.id === variantId);

    if(quantity < min || quantity > max || (cartItem && parseInt(cartItem.quantity) + quantity > max)){
        const errorQuantityMessage = document.querySelector('.error-quantity-message');
        errorQuantityMessage.classList.add('show');
        setTimeout(() => {
            errorQuantityMessage.classList.remove('show');
        }, 5000);
        return;
    }

    handleCartLoadingWrapper(true);
    fetch(`${ROUTES.cart_add_url_js}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity || 1
            })
    })
    .then(response => {
        return response.json();
    })
    .then((data) => {
        // console.log('Added to cart', data);
        updateCartHtml();
    })
    .then(()=>{
        handleSideModalOpen('cart')
    })
    .catch((error) => {
        console.error('Error adding to cart:', error);
        console.log(error);
    })
}

async function updateCartCount(count){
    const elementsCartCount = document.querySelectorAll('.cart-count');
    elementsCartCount.forEach(element => {
        element.textContent = count;
    });
}

async function updateCartHtml(){
    fetch(`${ROUTES.cart_url}`)
    .then(response => {
        return response.text();
    })
    .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newCartHtml = html.querySelector('cart-form');
        document.querySelector('cart-form').innerHTML = newCartHtml.innerHTML;
        const cartCount = html.querySelector('.cart-count');
        updateCartCount(cartCount.textContent);
    })
    .catch((error) => {
        console.error('Error updating cart html:', error);
        console.log(error);
    })
    .finally(() => {
        handleCartLoadingWrapper(false);
    });

}

async function changeCartQuantity(id, quantity){
    try {
        handleCartLoadingWrapper(true);
        const response = await fetch(`${ROUTES.cart_change_url_js}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: id,
                quantity: quantity
            })
        })
        const data = await response.json();
        // console.log('Changed cart quantity', data);
        updateCartHtml();
    } catch (error) {
        console.error('Error changing cart quantity:', error);
        console.log(error);
    }

}
